"use client";

import { use } from "react";
import { PostDetail } from "../../../../_modules/components/PostDetail";

// Re-rooted thread view — "Continue this thread →" + comment permalinks.
export default function ForumCommentPermalinkPage({
  params,
}: {
  params: Promise<{ slug: string; commentId: string }>;
}) {
  const { slug, commentId } = use(params);
  return <PostDetail idOrSlug={slug} rootId={commentId} />;
}
